import Axios from "axios";
import errorHandler from "../../helpers/ErrorHandler";
import { antdAsyncMessageError, antdAsyncMessageLoading, antdAsyncMessageSuccess } from "../../helpers/AsyncMessage";

export const globalPostMethod = async (api_url, params = {}) => {
    const custom_id = Math.random().toString(36).substring(2, 15);
    try {
        antdAsyncMessageLoading({ key: custom_id });
        const { data } = await Axios.post(api_url, params);
        antdAsyncMessageSuccess({ key: custom_id });
        return { success: true, data };
    } catch (err) {
        errorHandler(err);
        antdAsyncMessageError({ key: custom_id });
        return { success: false };
    }
};


export const globalDeleteMethod = async (api_url) => {
    const custom_id = Math.random().toString(36).substring(2, 15);
    try {
        antdAsyncMessageLoading({ key: custom_id });
        const { data } = await Axios.delete(api_url);
        antdAsyncMessageSuccess({ key: custom_id });
        return { success: true, data };
    } catch (err) {
        errorHandler(err);
        antdAsyncMessageError({ key: custom_id });
        return { success: false };
    }
};